import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { useData } from '../Form';
import { useStep } from '../Form';
import BackAndNextButtons from '../components/BackAndNextButtons';

export default function EmergencyForm() {

  const { data, updateData } = useData();
  const { incrementStep } = useStep();

  const [values, setValues] = useState({
    firstName_emergency: data.firstName_emergency ?? "",
    lastName_emergency: data.lastName_emergency ?? "",
    email_emergency: data.email_emergency ?? "",
    phoneNumber_emergency: data.phoneNumber_emergency ?? "",
    isMinor: data.isMinor ?? false,
  });

  const [error, setError] = useState({
    firstName_emergency: false,
    lastName_emergency: false,
    email_emergency: false,
    phoneNumber_emergency: false,
  });

  function checkForErrors() {
    let newError = {
      firstName_emergency: values.firstName_emergency === "",
      lastName_emergency: values.lastName_emergency === "",
      email_emergency: values.email_emergency === "" || !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i).test(values.email_emergency),
      phoneNumber_emergency: values.phoneNumber_emergency === "" || !(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i).test(values.phoneNumber_emergency),
    }
    setError(newError);
    return Object.keys(newError).some((k) => newError[k]);
  }

  function handleNext() {
    if (checkForErrors()) {
      // If there are errors, don't proceed
      return;
    } else {
      incrementStep(); // Proceed to the next step
      updateData(values); // Save the current form data
    }
  }

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Emergency Contact
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            error={error.firstName_emergency}
            helperText={error.firstName_emergency ? "Cannot be left blank" : ''}
            id="eFirstName"
            name="eFirstName"
            label="First name"
            fullWidth
            autoComplete="given-name"
            variant="standard"
            value={values.firstName_emergency}
            onChange={(e) => {
              setValues({ ...values, ...{ firstName_emergency: e.target.value } })
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            error={error.lastName_emergency}
            helperText={error.lastName_emergency ? "Cannot be left blank" : ''}
            id="eLastName"
            name="eLastName"
            label="Last name"
            fullWidth
            autoComplete="family-name"
            variant="standard"
            value={values.lastName_emergency}
            onChange={(e) => {
              setValues({ ...values, ...{ lastName_emergency: e.target.value } })
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            error={error.email_emergency}
            helperText={error.email_emergency ? "Invalid email" : ''}
            id="eEmail"
            name="eEmail"
            label="Email"
            fullWidth
            autoComplete="email"
            variant="standard"
            value={values.email_emergency}
            onChange={(e) => {
              setValues({ ...values, ...{ email_emergency: e.target.value } })
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            error={error.phoneNumber_emergency}
            helperText={error.phoneNumber_emergency ? "Invalid phone number" : ''}
            id="ePhone"
            name="ePhone"
            label="Phone Number"
            fullWidth
            autoComplete="tel-national"
            variant="standard"
            value={values.phoneNumber_emergency}
            onChange={(e) => {
              setValues({ ...values, ...{ phoneNumber_emergency: e.target.value } })
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox checked={values.isMinor}
              onChange={() => setValues({ ...values, ...{ isMinor: !values.isMinor } })} />}
            label="I am under 18 yrs old" />
        </Grid>
      </Grid>
      <BackAndNextButtons handleNext={handleNext}></BackAndNextButtons>


    </React.Fragment>
  );
}
